<template>
    <v-container
        class="mx-0 px-0 py-0 my-0"
        fluid
        no-gutters
    >
        <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="#1b2f5a"
            @click="toTop"
          >
            <v-icon large color="white">mdi-chevron-up</v-icon>
        </v-btn>
        <v-row no-gutters class="mb-10">
            <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
                <v-img
                    height="auto"
                    width="100vw"
                    contain 
                    :src="$route.path==='/Teams' ? require('@/assets/teams.jpg') : require('@/assets/epixeiriseis ekptoseis.jpg')">
                </v-img>
            </v-col>
        </v-row>
        <v-row class="page-gutter" no-gutters v-if="$route.path==='/Partners'">
            <v-col 
                cols="12"
            >
                <filters-component @fetchData="fetchFilteredData"/>
            </v-col>
        </v-row>
        <v-row ref="partners" class="page-gutter mt-6">
            <v-col
                v-for="entity in data"
                :key="entity.id"
                cols="12"
                sm="6"
                lg="4"
                class="pa-3 align-self-stretch"
            >
                <entity-card :entity="entity" :kind="$route.path == '/Teams' ? 'team' : 'partner'" />
            </v-col>
            <v-col v-if="!loading && !data.length" cols="12" class="text-center py-12" style="color: rgba(27, 47, 90, 0.7);">
                Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε άλλα φίλτρα.
            </v-col>
        </v-row>
        <v-row no-gutters class="mb-12 mt-16">
            <v-col cols="12" align="center">
                <v-pagination
                v-if="lastPage > 1"
                    v-model="page"
                    :length="lastPage"
                    :total-visible="$vuetify.breakpoint.mobile ? 5 : 7"
                    @input="fetchData(true)"
                ></v-pagination>
            </v-col>
        </v-row>
        <paron-card-section/>
        <v-overlay :value="loading">
            <div class="text-center">
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="#1b2f5a"
                    indeterminate
                />
            </div>
        </v-overlay>
    </v-container>
</template>

<script>
import restApi from "@/rest-api";
import FiltersComponent from '@/components/FiltersComponent.vue'
import EntityCard from '@/components/EntityCard.vue'
import ParonCardSection from "../components/ParonCardSection.vue"

export default {
  components: { FiltersComponent, ParonCardSection, EntityCard },
  data() {
        return {
            data:[],
            fab: false,
            lastPage: 1,
            page: 1,
            loading: false,
            filtersApplied: false,
            filters: { }
        }
    },
    watch:{
        $route(to, from) {
            if(to !== from ) {
                this.data = []
                this.page = 1
                this.lastPage = 1
                if(to.name === 'Teams') {
                    this.fetchData()
                }
            }
        },
        page(newPage) {
            this.$store.dispatch('setPage', newPage)
        }
    },
    mounted() {
    },
    created() {
        this.page = parseInt(this.$store.getters.getPage.page)
        if(this.$route.path.includes('Teams')) {
            this.fetchData()
        }
    },
    methods: {
        fetchFilteredData(filters) {
            this.page = 1
            this.$store.dispatch('setPage', 1)
            this.data = []
            this.filters = filters
            this.fetchData(this.filtersApplied)
            this.filtersApplied = true
        },
        fetchData(scrollToList = false) {
            this.loading = true
            if(this.$route.path=="/Teams"){
                this.fetchTeams(this.filters);
            }else {
                this.fetchPartners(this.filters);
            }
            // only scroll down for a page change or new filters, not when the page first opens
            if (scrollToList) {
                this.toPartners()
            }
        },
        fetchTeams(filters) {
            var search = `/team/filtered?page=${this.page}&per_page=12&available=true`;
            restApi
            .post(search, filters)
            .then(response => {
                this.data = response.data
                this.lastPage = response.last_page
                this.loading = false
            })
            .catch((error) => {
                console.log(error);
                this.loading = false
            });
        },
        fetchPartners(filters) {
            var search = `/partner/filtered?page=${this.page}&per_page=12`;
            restApi
            .post(search, filters)
            .then(response => {
                // the backend already orders the list (promoted first, then by distance when a
                // location is set); re-sorting one page here broke that order and crashed when
                // no location or coordinates were set
                this.data = response.data
                this.lastPage = response.last_page
                this.loading = false
            })
            .catch((error) => {
                console.log(error);
                this.loading = false
            });
        },
        onScroll (e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset ||   e.target.scrollTop || 0
            this.fab = top > 20
        },
        toPartners () {
            this.$vuetify.goTo(this.$refs.partners)
        },
        toTop() {
            this.$vuetify.goTo(0)
        }
    }
}
</script>
